export default function ChatGPT_3_5() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">ChatGPT-3.5</h1>
    </div>
  );
}
